/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentVersionBatchResponse {
    getFixupPrototypeFunction() { return AwsSsmDocumentVersionBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentVersionBatchResponse>): AwsSsmDocumentVersionBatchResponse {
        let obj = Object.assign(new AwsSsmDocumentVersionBatchResponse(), model);
        AwsSsmDocumentVersionBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentVersionBatchResponse>): AwsSsmDocumentVersionBatchResponse {
        if (!model) return null;
        return AwsSsmDocumentVersionBatchResponse.newInstance(<AwsSsmDocumentVersionBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentVersionBatchResponse) {
        if (!obj) return;

        models.AwsSsmDocumentVersionBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentVersionBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentVersionBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSsmDocumentVersionDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSsmDocumentVersionDetails; };

}
